// extracted by mini-css-extract-plugin
module.exports = {"myModal":"MyModal_myModal__2io0e","myModalContent":"MyModal_myModalContent__1JxvR","active":"MyModal_active__22QGY"};